import { Typography, TypographyProps } from '@material-ui/core';
import React, { FC } from 'react';

export type AppTextProps = TypographyProps;

export const AppText: FC<AppTextProps> = (props) => <Typography {...props} />;
